export default [{
    path: '/loan',
    component: () => import('@/view/loan/index.vue'),
    children: [{
        name: 'loan/index',
        path: '/loan/index',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/loan/loan.vue')
    }, {
        name: 'loan/sign',
        path: '/loan/sign',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/loan/sign.vue')
    }, {
        name: 'loan/result',
        path: '/loan/result',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/loan/result.vue')
    }, {
        name: 'loan/plan',
        path: '/loan/plan',
        meta: {
            needLogin: true
        },
        component: () => import('@/view/loan/plan.vue')
    }]
}, {
    path: '/callback/loan/sign',
    meta: {
        needLogin: true
    },
    redirect: to => {
        let callback = to.query.callbackString
        let obj = {}
        try {
            obj = JSON.parse(callback)
        } catch (e) {
            // empty code
        }
        return {
            name: 'loan/sign',
            query: obj
        }
    }
}, {
    name: 'loan/log',
    path: '/loan/log',
    component: () => import('@/view/loan/log.vue')
}]